import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { pageWindow, rangeLabel } from '../utils/pagination';

/**
 * Pagination d'une liste : numérotée dès `md`, compacte « Précédent / Page x sur y / Suivant »
 * sur mobile, masquée quand il n'y a qu'une page.
 */
const ListPagination = ({ page, totalPages, totalItems, pageSize, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <nav
      aria-label="Pagination"
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 px-4 py-3"
    >
      <p className="text-sm text-gray-600 text-center md:text-left">{rangeLabel(page, pageSize, totalItems)}</p>

      <div className="flex items-center justify-between gap-2 md:hidden">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          <ChevronLeft className="w-4 h-4" />
          Précédent
        </Button>
        <span className="text-sm text-gray-700">
          Page {page} sur {totalPages}
        </span>
        <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
          Suivant
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>

      <div className="hidden md:flex items-center gap-1">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          <ChevronLeft className="w-4 h-4" />
          Précédent
        </Button>
        {pageWindow(page, totalPages).map((value, index) =>
          value === null ? (
            <span key={`gap-${index}`} className="px-2 text-gray-500" aria-hidden="true">
              …
            </span>
          ) : (
            <Button
              key={value}
              size="sm"
              variant={value === page ? 'default' : 'outline'}
              aria-current={value === page ? 'page' : undefined}
              aria-label={`Page ${value}`}
              onClick={() => onPageChange(value)}
            >
              {value}
            </Button>
          ),
        )}
        <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
          Suivant
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </nav>
  );
};

export default ListPagination;
